import { setBusinessInfo, useBusinessInfo } from '~/lib/Queries';
import useBusinessPostApi from '~/lib/useBusinessPostApi';

/**
 * This list corresponds to the enum FeatureType in Features.php
 */
export const FEATURE_COUPONS = 'coupons';
export const FEATURE_SUBSCRIPTIONS = 'subscriptions';
export const FEATURE_PACKAGES = 'packages';
export const FEATURE_WAITLIST = 'waitlist';
export const FEATURE_GIFT_CERTIFICATES = 'giftcertificates';
export const FEATURE_MARKETING = 'marketing';

export function useFeatures() {
    const { data } = useBusinessInfo();
    const allFeatures = data?.features || {};
    const { save, isSaving } = useBusinessPostApi(`/toggle-feature`);

    function isEnabled(featureType) {
        return !!allFeatures[featureType];
    }

    function toggle(key, newEnabled) {
        return save({
            key: key,
            enabled: newEnabled,
        }).then(result => {
            setBusinessInfo(result);
        });
    }

    return {
        isEnabled,
        toggle,
        isSaving,
    };
}
